import { css } from 'lit';
import { GrafanaConfig } from '@config/ConfigDashboard';

// eslint-disable-next-line jsdoc/require-jsdoc
async function checkGrafanaHealth(): Promise<boolean> {
	try {
		const response = await fetch(`${GrafanaConfig.SERVER_URL}/api/health`);
		return response.ok;
	} catch (error) {
		console.error('Error performing health check on grafana server', error);
		return false;
	}
}

// eslint-disable-next-line jsdoc/require-jsdoc
export default function pollGrafanaHealth(intervalMs = 2000, attempts = 3): Promise<boolean> {
	return new Promise((resolve) => {
		let currentAttempt = 0;
		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		const interval = setInterval(async () => {
			if (currentAttempt === attempts) {
				clearInterval(interval);
				resolve(false);
				return;
			}

			currentAttempt += 1;
			if (await checkGrafanaHealth()) {
				clearInterval(interval);
				resolve(true);
			}
		}, intervalMs);
	});
}
